"use client";

import { useFetchApi } from "@/composables/useFetchApi";
import type { StrapiCollectionResponse, StrapiEntity, StrapiQuery, StrapiQueryValue } from "@/lib/strapi";
import type { ProductReviewAttributes } from "@/services/productReview";

export type UseProductReviewsOptions = {
  enabled?: boolean;
  query?: StrapiQuery;
  populate?: StrapiQueryValue;
  pageSize?: number;
  withBrandFilter?: boolean;
  path?: string;
  initialData?: StrapiCollectionResponse<ProductReviewAttributes> | null;
};

export function useProductReviews(options?: UseProductReviewsOptions) {
  const query: StrapiQuery = {
    ...(options?.query ?? {}),
    sort: options?.query?.sort ?? ["updatedAt:desc"],
    pagination: {
      ...(typeof options?.query?.pagination === "object" && options?.query?.pagination !== null
        ? (options.query.pagination as Record<string, unknown>)
        : {}),
      pageSize: options?.pageSize ?? 3,
    },
  };

  if (options?.populate !== undefined) {
    query.populate = options.populate;
  } else if (options?.query?.populate !== undefined) {
    query.populate = options.query.populate;
  }

  const state = useFetchApi<StrapiCollectionResponse<ProductReviewAttributes>>(
    options?.path ?? "/product-reviews",
    {
      enabled: options?.enabled,
      query,
      withBrandFilter: options?.withBrandFilter ?? true,
      initialData: options?.initialData,
    },
  );

  const reviews: Array<StrapiEntity<ProductReviewAttributes>> = state.data?.data ?? [];

  return { ...state, reviews };
}
